import React, { useState, useRef, useCallback } from "react"
import {
  Row,
  Col
} from "reactstrap";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { getRolesSelector } from "../../../redux/selectors/AdminSelector";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import moment from 'moment';

const PositionFilter = (props) => {
  const { query, setQuery } = props
  const [closingDate, setClosingDate] = useState(null);
  const [createDate, setCreateDate] = useState(null);
  const formRef = useRef(null);
console.log(query);
  const titleChange = (value) => {
    console.log(value.keycode);
    if (value.keyCode === 13)
      setQuery({
        ...query,
        position_title: value.target.value,
      });
  };
  
  const createdChange = (value) => {
    if (value.keyCode === 13)
      setQuery({
        ...query,
        position_created_by : value.target.value,
      });
  };

  const locationChange = (value) => {
    if (value.keyCode === 13)
      setQuery({
        ...query,
        position_location: value.target.value,
      });
  };

  const remove = useCallback((key) => {
    setQuery(({ [key]: value, ...query }) => query);
  }, []);

  const handleClosingDate = (date) => {
    if (date) {
      setClosingDate(date);
      setQuery({
        ...query,
        position_closing_date: moment(date).format("MMM DD, YYYY"),
      });
    } else {
      remove('position_closing_date')
      setClosingDate(date);
    }
  };
  
  const handlesCreateDate= (date) => {
    if (date) {
      setCreateDate(date);
      setQuery({
        ...query,
        create_date: moment(date).format("MMM DD, YYYY"),
      });
    } else {
      remove('create_date')
      setCreateDate(date);
    }
  };

  const clearFilters = () => {
    setClosingDate(null);
    setQuery({});
    formRef.current.reset();
  };

  return (
    
    <div className="card candidate-filters  border border-primary">
      <div className="card-header">
        <h5 className="card-title">Positions Filters</h5>
      </div>
      <form ref={formRef} className=" card-body pb-0 ">
        <Row>
          <Col lg={10}>
            <Row>
              <Col lg={3}>
                <div className="form-group">
                  <input
                    name="name"
                    placeholder="Position title"
                    className="form-control"
                    onKeyUp={(e) => titleChange(e)}
                    type="text"
                  />
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group">
                  <input
                    name="name"
                    placeholder="Created By"
                    className="form-control"
                    onKeyUp={(e) => createdChange(e)}
                    type="text"
                  />
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group">
                  <input
                    name="email"
                    placeholder="Location"
                    className="form-control"
                    onKeyUp={(e) => locationChange(e)}
                    type="text"
                  />
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group">
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker
                      autoOk
                      clearable
                      format="yyyy-MM-dd"
                      className="form-control"
                      placeholder="Closing Completed"
                      value={closingDate}
                      onChange={(e) =>handleClosingDate(e)
                      }
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </Col>
            </Row>
          </Col>
          <Col lg={2}>
            <Row className="mb-3">
              <Col lg={12}>
                <div className="form-group">
                  <button type="button" className="btn btn-secondary btn-block" onClick={() => clearFilters()}>
                    Clear Filters
                  </button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </form>
    </div>
  )
}
const mapStateToProps = (state) => {
  return {
    Roles: getRolesSelector(state),
  }
}

export default (connect(mapStateToProps, null)(PositionFilter));
